<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full">
        <h1 class="text-app-primary-10 mb-18">Termin buchen</h1>

        @if (activeDoctor) {
            <div class="grid grid-cols-1 xl:grid-cols-12 gap-8">
                <!-- Doctor Info Column -->
                <div class="xl:col-span-4">

                    @if (selectedReservation) {
                        <div
                            class="card bg-app-background-10 rounded-button p-6 shadow-sm border border-app-primary-10/5 h-fit sticky top-0 mb-8">
                            <div class="flex flex-col">
                            <span class="text-lg font-bold text-app-primary-10">
                                Termin
                            </span>
                                <div class="flex flex-col gap-2 mt-4">
                                    <div class="flex justify-between">
                                        <span
                                            class="text-lg font-bold text-app-primary-10">{{ selectedReservation!.from | date: 'dd.MM.yyyy - HH:mm' }}
                                            Uhr</span>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-between gap-8 mt-8 flex-col 2xl:flex-row">
                                @switch (selectedPage) {
                                    @case (1) {
                                        <button class="btn primary-button w-full" (click)="toPage(2)">Termin
                                            reservieren
                                        </button>
                                    }
                                    @case (2) {
                                        <button class="btn tertiary-button w-full" (click)="toPage(1)">
                                            <span>Zurück</span>
                                        </button>
                                        <button class="btn primary-button w-full" (click)="toPage(3)">
                                            <span>Zahlungspflichtig buchen</span>
                                        </button>
                                    }
                                }
                            </div>
                        </div>
                    }
                    <div
                        class="card bg-app-background-10 rounded-button p-6 shadow-sm border border-app-primary-10/5 h-fit xl:sticky top-0">
                        <button class="btn tertiary-button w-full mt-4" (click)="toDoctorSelect()">
                            <span>Anderen Arzt auswählen</span>
                        </button>
                        <div class="flex flex-col gap-4 my-8">
                            <div class="flex flex-col">
                                <span class="text-lg font-bold text-app-primary-10">
                                    {{ activeDoctor.title ? activeDoctor.title + ' ' : '' }}{{ activeDoctor.firstName }} {{ activeDoctor.lastName }}
                                </span>
                                <span class="text-app-primary-10/70 font-medium">{{ activeDoctor.practice.name }}</span>
                            </div>

                            <div class="flex flex-col text-sm text-app-primary-10/70">
                                <span>{{ activeDoctor.practice.address.street }} {{ activeDoctor.practice.address.houseNumber }}</span>
                                <span>{{ activeDoctor.practice.address.zipCode }} {{ activeDoctor.practice.address.city }}</span>
                            </div>

                            <div class="border-t border-app-primary-10/10 pt-6">
                                <div class="text-sm font-bold text-app-primary-10 mb-3">Voraussichtliche Kosten:</div>
                                <div class="flex flex-col gap-2 text-sm text-app-primary-10/70">
                                    <div class="flex justify-between">
                                        <span>Termin:</span>
                                        <span
                                            class="font-bold text-app-primary-10">{{ activeDoctor.costs.treatmentCosts | currency:'EUR' }}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span>Rezeptausstellung:</span>
                                        <span
                                            class="font-bold text-app-primary-10">{{ activeDoctor.costs.prescriptionCosts | currency:'EUR' }}</span>
                                    </div>
                                    <div class="flex justify-between">
                                        <span>Rezeptversand:</span>
                                        <span
                                            class="font-bold text-app-primary-10">{{ activeDoctor.costs.shippingCostsForPrescription | currency:'EUR' }}</span>
                                    </div>
                                </div>
                                <div class="mt-4 text-[10px] text-app-primary-10/50 leading-tight">
                                    Die Kosten können je nach ausgewählter Apotheke variieren. Zusätzlich können Kosten
                                    für Medikamente entstehen.
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Booking Process Column -->
                <div class="xl:col-span-8">
                    <!-- Step 1: Calendar -->
                    @if (selectedPage == 1) {
                        <div class="card bg-white rounded-lg p-6 shadow-sm border border-app-primary-10/5">
                            <div class="calendar-container mb-8">
                                <full-calendar #calendar [options]="activeDoctor.calendarOptions"
                                               [events]="activeDoctor.mappedAppointments"></full-calendar>
                            </div>
                        </div>
                    }

                    <!-- Step 2: Pharmacy -->
                    <!--                    @if (selectedPage == 2) {-->
                    <!--                        <div class="card bg-white rounded-lg p-6 shadow-sm border border-app-primary-10/5">-->
                    <!--                            <p class="text-app-primary-10/70 mb-8">-->
                    <!--                                Wählen Sie eine Apotheke aus unserem Apothekenverbund, um Versandkosten zu sparen oder-->
                    <!--                                geben Sie Ihre eigene Apotheke an.-->
                    <!--                            </p>-->

                    <!--                            <form [formGroup]="pharmacyForm" class="flex flex-col gap-6">-->
                    <!--                                <div class="flex flex-col gap-2">-->
                    <!--                                    <label class="text-sm font-bold text-app-primary-10">Apotheke auswählen</label>-->
                    <!--                                    <mat-select formControlName="id" (selectionChange)="checkDisabledState()"-->
                    <!--                                                class="custom-select">-->
                    <!--                                        <mat-option value="">Bitte wählen</mat-option>-->
                    <!--                                        <mat-option value="custom">Eigene Apotheke</mat-option>-->
                    <!--                                        <mat-option value="none">Keine Apotheke (Rezept direkt an mich)</mat-option>-->
                    <!--                                        @for (pharmacy of pharmacyList; track pharmacy.id) {-->
                    <!--                                            <mat-option [value]="pharmacy.id">-->
                    <!--                                                {{ pharmacy.name }}-->
                    <!--                                                @if (pharmacy.id === loggedInPatient?.regularPharmacyId) {-->
                    <!--                                                    (Standard)-->
                    <!--                                                }-->
                    <!--                                            </mat-option>-->
                    <!--                                        }-->
                    <!--                                    </mat-select>-->
                    <!--                                </div>-->

                    <!--                                @if (pharmacyForm.get('id')?.value === 'custom') {-->
                    <!--                                    <div [formGroup]="customPharmacyForm"-->
                    <!--                                         class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-app-background-20 rounded-lg border border-app-primary-10/5">-->
                    <!--                                        <div class="md:col-span-2">-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">Name der-->
                    <!--                                                Apotheke</label>-->
                    <!--                                            <input matInput formControlName="name" placeholder="Apotheke am Markt"-->
                    <!--                                                   class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                        <div>-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">Straße</label>-->
                    <!--                                            <input matInput formControlName="street" class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                        <div>-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">Hausnummer</label>-->
                    <!--                                            <input matInput formControlName="houseNumber" class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                        <div>-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">PLZ</label>-->
                    <!--                                            <input matInput formControlName="zipCode" class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                        <div>-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">Stadt</label>-->
                    <!--                                            <input matInput formControlName="city" class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                        <div class="md:col-span-2">-->
                    <!--                                            <label class="text-xs font-bold text-app-primary-10">Telefonnummer</label>-->
                    <!--                                            <input matInput formControlName="phoneNumber" class="app-input">-->
                    <!--                                        </div>-->
                    <!--                                    </div>-->
                    <!--                                }-->
                    <!--                            </form>-->
                    <!--                        </div>-->
                    <!--                    }-->

                    <!-- Step 3: Summary -->
                    @if (selectedPage == 2) {
                        <div class="card bg-white rounded-lg p-6 shadow-sm border border-app-primary-10/5">
                            <div class="flex flex-col gap-8">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                                    <div class="flex flex-col gap-4">
                                        <div
                                            class="text-lg font-bold text-app-primary-10 border-b border-app-primary-10/10 pb-2">
                                            Termindetails
                                        </div>
                                        <div class="flex flex-col">
                                            <span class="text-sm text-app-primary-10/50">Datum & Uhrzeit</span>
                                            <span class="font-bold text-app-primary-10">
                                                {{ reservedAppointment?.from | date: 'EEEE, dd.MM.yyyy' }}
                                            </span>
                                            <span class="font-bold text-app-primary-10">
                                                {{ reservedAppointment?.from | date: 'HH:mm' }}
                                                - {{ reservedAppointment?.to | date: 'HH:mm' }} Uhr
                                            </span>
                                        </div>
                                    </div>

                                    <div class="flex flex-col gap-4">
                                        <div
                                            class="text-lg font-bold text-app-primary-10 border-b border-app-primary-10/10 pb-2">
                                            Rezept
                                        </div>
                                        <div class="flex flex-col">
                                            <span class="text-sm text-app-primary-10/70">Besprechen Sie wie Sie Ihr Rezept erhalten mit Ihrem Arzt.</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="bg-app-background-20 p-6 rounded-lg flex flex-col gap-4 mt-4">
                                    <mat-checkbox [(ngModel)]="termsAndConditionsAccepted">
                                        Ich akzeptiere die <a (click)="toAgbsPage(); $event.stopPropagation()"
                                                              class="underline hover:text-app-primary-10">AGB</a>
                                    </mat-checkbox>
                                    <mat-checkbox [(ngModel)]="dataProtectionAgreementAccepted">
                                        Ich habe die <a (click)="toDataProtectionSite(); $event.stopPropagation()"
                                                        class="underline hover:text-app-primary-10">Datenschutzbestimmungen</a>
                                        gelesen und akzeptiert
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
